export default function ChatgptDebugCode() {
  return <h2>Chatgpt Debug Code</h2>;
}
